import type { ShareServiceConfig } from "../../../shared/index.js";

export const qzone: ShareServiceConfig = {
  link: "http://sns.qzone.qq.com/cgi-bin/qzshare/cgi_qzshare_onekey?url=[url]",
  color: "#0985DD",
  shape:
    '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1024 1024"><path d="M852 688c36-6 18-19 3-18-26 3-64 3-106 2l5 29a1047 1047 0 0 0 98-13m110-278a8 8 0 0 0-7-6l-301-44L520 89c-3-6-13-6-16 0L370 360 69 404a9 9 0 0 0-7 6 9 9 0 0 0 3 9l217 211-51 299a8 8 0 0 0 3 8c3 3 6 3 10 1l268-141 269 141 4 1 5-1c3-2 4-5 3-9l-39-228c-43 3-86 5-122 5-123 0-215-6-216-6-11-1-21-8-24-19a26 26 0 0 1 10-28l247-180c-159-13-293-10-294-10-21 1-41-6 1-23 7-3 174-38 367-12 11 1 19 9 22 19a26 26 0 0 1-10 28L493 651c44 9 160 19 256 21l-7-42 217-211a8 8 0 0 0 3-9"/></svg>',
};
